import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ManualVerificationTemporaryDetails {
  dynamicURLValues: any;
  dynamicBodyValues: any;
}

const initialState: ManualVerificationTemporaryDetails = {
  dynamicURLValues: {},
  dynamicBodyValues: {},
};

const manualVerificationTemporaryDetailsSlice = createSlice({
  name: 'manualVerificationTemporaryDetails',
  initialState,
  reducers: {
    updateDynamicURLValues(state, action: PayloadAction<object>) {
      state.dynamicURLValues = action.payload;
    },
    updateDynamicBodyValues(state, action: PayloadAction<object>) {
      state.dynamicBodyValues = action.payload;
    },
    resetManualVerificationTemporaryDetails() {
      return { ...initialState };
    },
  },
});

export const {
  updateDynamicURLValues,
  updateDynamicBodyValues,
  resetManualVerificationTemporaryDetails,
} = manualVerificationTemporaryDetailsSlice.actions;

export default manualVerificationTemporaryDetailsSlice.reducer;
